import { getBaseUrl, isTimeStampElapsed, makeRequest } from './joshCommonUtil';
const APP_VERSION = require('../package.json').version;
const isBrowser = process.browser;
const serverUrl = '/webview/apiwbody';
const env = process.env.NEXT_PUBLIC_ENV || 'PROD';
const handshakeKey = 'HANDSHAKE';
const TWELVE_HOUR = 60 * 60 * 12;

let defaultConfig = {
  method: "POST",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
};

const urlReplaceLogic = (url) => {
  const isCoolfieUrl = url.includes('coolfie.io');

  if (isCoolfieUrl) {
    return url.includes('-internal.coolfie.io') ? url
      :
      url.replace('.coolfie.io', '-internal.coolfie.io');
  } else {
    return url;
  }
}


const localStorageWithExpiry = (key, periodInSeconds) => {
  if (typeof window == 'undefined') {
    console.error("Only works on client.");
    return -1;
  }

  let value = localStorage && localStorage.getItem(key);
  if (value) {
    try {
      const valueObj = JSON.parse(value)
      if (isTimeStampElapsed(valueObj.timeStamp, periodInSeconds)) {
        // delete the key and fetch data and update
        console.log("timestamp elapsed")
        localStorage.removeItem(key);
        return null;
      } else {
        return valueObj;
      }
    } catch (err) {
      console.log("error parsing", null)
    }
  }
  return null;
}

// Handshake API.
// Called once for a client per day and store it in localstorage[handshake].
const handshake = async (lang_code = 'en', userDetails, status) => {
  console.log("handshake invoked")
  const handshakeLocal = localStorageWithExpiry(handshakeKey, TWELVE_HOUR);
  const handshakeLocalLang = handshakeLocal && handshakeLocal.data && handshakeLocal.data.data && handshakeLocal.data.data.lang_code || 'en';
  // Initialization return if found else fetch
  if (status == 'INIT') {
    if (handshakeLocal) {
      console.log("We are returning data INIT", handshake.data)
      return (handshakeLocal.data);
    }
  } else {
    // Return what we have on localStorage.
    if (handshakeLocal && lang_code == handshakeLocalLang) {
      console.log("We are returning data here", handshake.data)
      return (handshakeLocal.data);
    }
  }
  const apiEndPoint = `/api/v1/josh/handshake`;
  const url = getBaseUrl(env).baseUrlGateway + apiEndPoint;
  let reqUrl = url;
  const coolfie_debug_info = `appVersion=4.10.10.2109152116.2&osVersion=10&clientId=7faea5da-b9b1-4f39-bd20-96f8e7180bd2&androidId=3e47cefed996cbe5&installSource=CoolfieHome^4.10.10^PLAYSTORE&user_lang=${lang_code}&nav_lang=${lang_code}&width=720&height=1370`;
  const reqBody = {
    "android_id": "3e47cefed996cbe5",
    "appOpenEvent": false,
    "client_info": {
      "app_language": "hi,en",
      "app_version": "4.10.10.21",
      "brand": "Josh",
      "default_notification_lang": "hi,en",
      "device": "android",
      "gaid": "8283eea9-3bf2-4923-bc36-d9ffd2d69a53",
      "gaid_opt_out_status": false,
      "height": 1370,
      "manufacturer": "samsung",
      "model": "SM-M105F",
      "os_version": "10",
      "width": 720,
      "android_id": "3e47cefed996cbe5",
      "client_id": "7faea5da-b9b1-4f39-bd20-96f8e7180bd2",
      "udid": "3e47cefed996cbe5"
    },
    "connection_info": {
      "cellid": "-------Gsm",
      "connection": "w",
      "ipAddress": "192.168.0.185"
    },
    "handshake_version": "",
    "install_type": "NA",
    "location_info": {
      "is_GPS_location": false,
      "lat": "",
      "lon": ""
    },
    "packageName": "com.eterno.shortvideos",
    "referrer": "utm_source=google-play&utm_medium=organic",
  };

  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };

  config.method = 'POST';
  config.body = JSON.stringify(reqBody);

  if (isBrowser) {
    config.method = 'POST';
    reqUrl = serverUrl;
    config.body = JSON.stringify({ method: "POST", url: url, body: reqBody, coolfie_debug_info: coolfie_debug_info });
  } else {
    config.headers["coolfie-debug-info"] = coolfie_debug_info;
  }

  const response = await makeRequest(reqUrl, config);
  // update the response in the localstorage
  const storeVal = { data: response, timeStamp: new Date().getTime() }
  if (response && response.data != null) {
    localStorage && localStorage.setItem(handshakeKey, JSON.stringify(storeVal));
  }
  console.log('response In handshake', response);
  return response || {};
}

export default handshake;